import { render, staticRenderFns } from "./VtLoading.vue?vue&type=template&id=5e3281d9&scoped=true&"
import script from "./VtLoading.vue?vue&type=script&lang=js&"
export * from "./VtLoading.vue?vue&type=script&lang=js&"
import style0 from "./VtLoading.vue?vue&type=style&index=0&id=5e3281d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3281d9",
  null
  
)

export default component.exports